const DB_NAME = "ERP_DB";
const DB_VERSION = 2;

const FILE_STORE_NAME = "files";
const FILE_STORE_CONFIG = {
  name: FILE_STORE_NAME,
  keyPath: "uid",
  autoIncrement: true,
  indexes: [
    { name: "uid", keyPath: "uid", options: { unique: true } },
    { name: "file", keyPath: "file", options: { unique: false } },
    { name: "retries", keyPath: "retries", options: { unique: false } },
    { name: "meta", keyPath: "meta", options: { unique: false } },
    { name: "type_value", keyPath: ["type", "value"], options: { unique: false } },
  ],
};

export { DB_NAME, DB_VERSION, FILE_STORE_NAME, FILE_STORE_CONFIG };
